<template>
    <v-layout row wrap text-xs-center>
        <v-flex xs12 sm6>
            <v-text-field label="Email*"
                          v-model="form.email"
                          v-validate="'required|email'"
                          :error-messages="errors.first('email') || errors.first('credentials')"
                          data-vv-name="email"
                          solo></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
            <v-text-field label="Password"
                          v-model="form.password"
                          v-validate="'required|min:1'"
                          :error-messages="errors.first('password') || errors.first('credentials')"
                          data-vv-name="password"
                          type="password"
                          solo></v-text-field>
        </v-flex>
        <v-flex rememberme xs12 py-0>
            <v-checkbox  v-model="form.rememberMe"
                        label="Remember me"
                        :ripple="false" class="_checkbox"></v-checkbox>
        </v-flex>
        <div class="setting_element"><router-link to="/forgot-password"
                         flat
                         class="link-small"
                         tag="a">
                Forgot your password?
            </router-link></div>
        <v-flex xs12>
            <v-btn @click="login"
                   :loading="loading"
                   class="primary v-btn--default elevation-0">Login
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
  import { parseUserData } from '@/util'
  import { AUTH_KEY } from '@/config/constants'

  export default {
    name: 'auth-login-email',

    data () {
      return {
        loading: false,
        form: {
          email: '',
          password: '',
          rememberMe: false
        },
        showPassword: false
      }
    },

    methods: {
      login () {

        console.log("Full route object:", this.$route)
        console.log("Query params:", this.$route.query)
        const redirect = this.$route.query.redirect

        this.$validator.validateAll().then(result => {
          if (!result) return this.scrollToFirstError && this.scrollToFirstError()

          if (this.$auth.token()) {
            localStorage.removeItem(AUTH_KEY)
          }
          this.loading = true

          this.$auth.login({
            data: this.form,
            rememberMe: this.form.rememberMe
          })
          .then(res => {
            const user = parseUserData(res.data)
            this.$auth.user(user)
            localStorage.setItem('auth._user', JSON.stringify(user))

            // 🔑 Redirect logic
            // const redirect = this.$route.query.redirect
            console.log(redirect,"redirect-harshit")
            const target = redirect || '/dashboard'

            if (this.$route.fullPath !== target) {
              this.$router.push(target).catch(err => {
                if (err.name !== 'NavigationDuplicated') console.error(err)
              })
            }

          })
          .catch(err => {
            if (err.response && err.response.status >= 401 && err.response.status < 500) {
              this.errors.add({
                field: 'credentials',
                msg: err.response.data.message
              })
            } else {
              console.error(err)
            }
          })
          .finally(() => {
            this.loading = false
          })
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
    ._checkbox
        margin-top 0
        padding-top 0
    .setting_element
      margin-left 14px
      margin-top -8px

    .rememberme .v-input__slot
      margin-bottom 0px !important
</style>



// WEBPACK FOOTER //
// src/views/app/auth/components/auth-login-email.vue